import { filterModalLogger } from '../../logger.instance';

export const filterModalInputLogger = filterModalLogger.extend('input');
